var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "10px",
    viewBox: "0 0 19 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "return-items-selected--2",
    transform: "translate(-41.000000, -189.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13-Copy",
    transform: "translate(21.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-left",
    transform: "translate(21.000000, 25.714286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.96287341,8.46781569 L4.08389795,8.33254783 C4.16410174,8.24289222 4.16410174,8.09752232 4.08389795,8.00784758 L1.02886265,4.5927838 L17.2393507,4.5927838 C17.3527759,4.5927838 17.4447381,4.48998406 17.4447381,4.36319196 L17.4447381,4.17186543 C17.4447381,4.04507334 17.3527759,3.9422736 17.2393507,3.9422736 L1.02886265,3.9422736 L4.08389795,0.527209821 C4.16410174,0.437554209 4.16410174,0.292184311 4.08389795,0.202509566 L3.96287341,0.0672417092 C3.88266962,-0.0224139031 3.75262515,-0.0224139031 3.67242135,0.0672417092 L0.0601528431,4.10518814 C-0.0200509477,4.19484375 -0.0200509477,4.34021365 0.0601528431,4.42988839 L3.67242135,8.46783482 C3.75262515,8.55749043 3.88266962,8.55749043 3.96287341,8.46781569 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowLeft);
export default __webpack_public_path__ + "static/media/long-arrow-left.aa4d1101e31f738ade942fb1f4b6a238.svg";
export { ForwardRef as ReactComponent };